import Auth from '../api/auth';
import { CLIENT_SESSION_HEADER, getClientSessionId } from './clientSessionId';

/* global Sentry */
const parseErrorCode = error => {
  // Send API errors to Sentry (4xx and 5xx)
  if (window.Sentry && error.response?.status >= 400) {
    const status = error.response?.status;
    const url = error.config?.url;
    const method = error.config?.method;

    // Skip 401 (unauthorized) and 404 (not found) - too noisy
    // Focus on 422 (validation), 500 (server errors), etc.
    if (status !== 401 && status !== 404) {
      Sentry.withScope(scope => {
        scope.setTag('api_error', 'true');
        scope.setContext('api_request', {
          url,
          method,
          status,
          response: error.response?.data,
        });
        scope.setExtra('request_url', url);
        scope.setExtra('request_method', method);
        scope.setExtra('response_status', status);
        scope.setExtra('response_data', error.response?.data);

        // Send as message with context, not exception
        Sentry.captureMessage(
          `API Error ${status}: ${method?.toUpperCase()} ${url}`,
          'error'
        );
      });
    }
  }
  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Carimba a ABA de origem em toda request do dashboard. O backend devolve
  // este id em `triggered_by.client_id` nos eventos de realtime do Pipeline,
  // e só a aba que originou a ação suprime o próprio eco (fase-57 RT-P0-1).
  wootApi.defaults.headers.common[CLIENT_SESSION_HEADER] = getClientSessionId();
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
